import { useNavigation } from 'expo-router'

const useResetNav = () => {
  const { reset } = useNavigation<any>()

  return (name: string) => {
    reset({
      index: 0,
      routes: [
        {
          name,
        },
      ],
    })
  }
}

export default useResetNav
